import { useRef, useState } from 'react';
import DealStageCell from 'dashboard409a/components/ValuationsTable/ValuationsTableRow/cells/DealStageCell';
import { DealStageOption } from 'dashboard409a/components/ValuationsTable/ValuationsTableRow/ValuationsTableRow.types';
import { useCellEditEnd } from 'dashboard409a/hooks/useCellEditEnd';
import { DealStageState } from 'dashboard409a/pages/Operations/components/ValuationDealInfo/ValuationDealInfo.props';
import { SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';

interface WorkboardDealStageCellProps {
  valuationRow: SimplifiedAttioValuation;
  dealStageOptions: DealStageOption[];
  onDealStageChange?: (row: SimplifiedAttioValuation, dealStageId: string) => Promise<void>;
  // Injected by ScalarSpreadsheet:
  cell?: unknown;
  disabled?: boolean;
}

const WorkboardDealStageCell = ({
  valuationRow,
  dealStageOptions,
  onDealStageChange,
}: WorkboardDealStageCellProps) => {
  const [dealStageState, setDealStageState] = useState<DealStageState>(DealStageState.IDLE);
  const cellRef = useRef<HTMLDivElement>(null);

  const handleDealStageEditEnd = useCellEditEnd(cellRef, () => setDealStageState(DealStageState.IDLE));

  const handleDealStageClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (dealStageState === DealStageState.IDLE) {
      setDealStageState(DealStageState.EDITING);
    }
  };

  const handleDealStageChange = async (value: { id: string; label: string } | null) => {
    if (!value || !onDealStageChange) {
      handleDealStageEditEnd();
      return;
    }
    setDealStageState(DealStageState.UPDATING);
    try {
      await onDealStageChange(valuationRow, value.id);
    } finally {
      handleDealStageEditEnd();
    }
  };

  return (
    <div
      ref={cellRef}
      style={{ width: '100%' }}
      onBlur={e => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setDealStageState(DealStageState.IDLE);
        }
      }}>
      <DealStageCell
        valuationRow={valuationRow}
        dealStageOptions={dealStageOptions}
        dealStageState={dealStageState}
        onDealStageClick={handleDealStageClick}
        onDealStageChange={handleDealStageChange}
        onDealStageEditEnd={handleDealStageEditEnd}
      />
    </div>
  );
};

export default WorkboardDealStageCell;
